/*
 * @Descripttion: AI 模型配置列表列
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2026-10-29 10:00:00
 */
/* eslint-disable react/display-name */
import { Switch, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { Dimen } from '../../models/dimen'
import { DateTimeFormat } from '../../models/datetime'

/** 模型用途：1 AI写病历、2 AI辅诊、3 AI语音输入写病历 */
export const getModelUseName = (modelUse: any): string => {
  switch (modelUse) {
    case 1:
      return 'AI写病历'
    case 2:
      return 'AI辅诊'
    case 3:
      return 'AI语音输入写病历'
    default:
      return '-'
  }
}

export interface ModelColumnsHandlers {
  onToggleEnable: (record: any, checked: boolean) => void
}

export const ModelColumns = (
  handlers: ModelColumnsHandlers,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '模型厂商',
      dataIndex: 'basePlat',
      align: 'center',
      width: Dimen.Category,
      ellipsis: true,
      render: (_, r) => (r?.basePlat ? r?.basePlat : '-'),
    },
    {
      title: '模型版本',
      dataIndex: 'modelVersion',
      align: 'center',
      width: Dimen.DepartmentName,
      ellipsis: true,
      render: (_, r) => (r?.modelVersion ? r?.modelVersion : '-'),
    },
    {
      title: '模型用途',
      dataIndex: 'modelUse',
      align: 'center',
      width: Dimen.Category,
      render: (_, r) => getModelUseName(r?.modelUse),
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: Dimen.Time,
      render: (_, r) =>
        r?.createTime ? moment(r.createTime).format(DateTimeFormat) : '-',
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      align: 'center',
      width: Dimen.Time,
      render: (_, r) =>
        r?.updateTime ? moment(r.updateTime).format(DateTimeFormat) : '-',
    },
    {
      title: '是否开启',
      dataIndex: 'isEnable',
      align: 'center',
      width: Dimen.State,
      render: function ModelEnable(_, r): ReactElement {
        return (
          <Switch
            size='small'
            checked={r?.isEnable == 1}
            checkedChildren='开启'
            unCheckedChildren='关闭'
            onChange={(checked) => handlers.onToggleEnable(r, checked)}
          />
        )
      },
    },
  ]
}
